import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { cloneDeep } from 'lodash';
import {
    getListViewByVisibleRange,
    createViewData,
    deleteViewData,
    updateViewData,
    getViewById,
} from '@/service/viewService';
import { getVisibleWidth } from './ListTicketKnowledgeHandler';

export const getVisibleRangeByVisibleType = (visibleType, argsCommon) => {
    let visibleRange = '';
    switch (visibleType) {
        case Constant.VISIBILITY_SETTING_TYPE.PRIVATE:
            visibleRange = argsCommon.userDetail.id;
            break;
        case Constant.VISIBILITY_SETTING_TYPE.PROJECT:
        case Constant.VISIBILITY_SETTING_TYPE.CUSTOMER:
            visibleRange = argsCommon.projectSelectedId;
            break;
        case Constant.VISIBILITY_SETTING_TYPE.IN_ORG:
            visibleRange = argsCommon?.corporationSelectedId
            break

        default:
            break;
    }

    return visibleRange;
}

export const sortListViewByOrder = (listView) => {
    return listView.sort((viewA, viewB) => {
        return viewA.order - viewB.order;
    });
};

export const getListViews = async (argsCommon, projectSelectedId, visibleType, knowledgeInfoChatAi = null, setIsScrollNewViews, isActionFromDialog = false) => {
    if (!visibleType || !projectSelectedId) return;
    let visibleRange = getVisibleRangeByVisibleType(visibleType, argsCommon);
    let listView = await getListViewByVisibleRange(
        argsCommon.API,
        projectSelectedId,
        visibleRange,
        visibleType
    );
    if (Utils.isEmptyArray(listView)) {
        return [];
    }
    //sort by order
    listView = sortListViewByOrder(listView);
    listView.forEach((view) => {
        view.isEditName = false;
        view.isMove = false;
    });

    let listViewShow = listView.filter(x => {
        const structure = Utils.convertJSONDataToObject(x.structure);
        if (structure.ticketProperty === Constant.TICKET_PROPERTY.SYNONYM) {
            const limitValue = argsCommon?.corporationDetail?.limitValue;
            let synonymSearch = limitValue?.synonymSearch;

            const projectSetting = Utils.convertJSONDataToObject(
                argsCommon?.projectInuseDetail?.projectSetting
            );
            
            if(argsCommon?.corporationDetail?.contractType === Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK) {
                let inviterSetting = Utils.convertJSONDataToObject(argsCommon?.corporationDetail?.inviterSetting);
                synonymSearch = inviterSetting.synonymSearch;

            }

            return (
                x.status === Constant.STATUS_VIEW.SHOW &&
                synonymSearch === Constant.STATUS_SERVICE_PERMISSION.ON &&
                projectSetting?.usingSynonym
            );
        }
        return x.status === Constant.STATUS_VIEW.SHOW;
    });

    // let listViewShow = listView.filter((view) => view.status === Constant.STATUS_VIEW.SHOW);

    // if (!Utils.isEmptyObject(argsCommon?.projectInuseDetail)) {
    //     const projectSetting = Utils.convertJSONDataToObject(argsCommon?.projectInuseDetail?.projectSetting);
    //     let usingSynonym = projectSetting?.usingSynonym;
    //     if (!usingSynonym) {
    //         listViewShow = listViewShow.filter(view => {
    //             let structure = Utils.convertJSONDataToObject(view.structure);
    //             return structure.ticketProperty !== Constant.TICKET_PROPERTY.SYNONYM
    //         });
    //     }
    // }
    
    if (!Utils.isEmptyArray(listViewShow) && listViewShow.length > 0) {
        if(isActionFromDialog) {
            argsCommon.setViewSelected(listViewShow[0]);
        }

        let firstViewStructure = Utils.convertJSONDataToObject(listViewShow[0].structure);

        if (knowledgeInfoChatAi) {
            let _viewSelected = listViewShow.find((view) => view.id === knowledgeInfoChatAi.viewSelectedId); 
            if (!_viewSelected) {
                argsCommon.setViewStructure({
                    ...firstViewStructure,
                    visibility: visibleType,
                });
                argsCommon.setViewSelected(listViewShow[0]);
            } else {
                argsCommon.setViewStructure({
                    ...knowledgeInfoChatAi.viewStructure,
                    visibility: visibleType,
                });
                argsCommon.setViewSelected(_viewSelected);
            }
            setIsScrollNewViews(true)
        } else {
            const ticketCreatedProjectId = firstViewStructure?.ticketCreatedProjectId || '';

            argsCommon.setDestinationPrjId(ticketCreatedProjectId);

            argsCommon.setViewStructure({
                ...firstViewStructure,
                visibility: visibleType,
                ticketCreatedProjectId: ticketCreatedProjectId
            });
            
            argsCommon.setViewSelected(listViewShow[0]);
        }
    }
    argsCommon.setListView(listView);
    

    return listViewShow;
};

export const getViewDefaultsChatAI = async (API, projectId, userDetail) => {
    const visibleType = Constant.VISIBILITY_SETTING_TYPE.PRIVATE;
    if (!projectId) return;

    let listView = await getListViewByVisibleRange(
        API,
        projectId,
        userDetail.id,
        visibleType
    );
    if (Utils.isEmptyArray(listView)) {
        return [];
    }
    //sort by order
    listView = sortListViewByOrder(listView);
    listView.forEach((view) => {
        view.isEditName = false;
        view.isMove = false;
    });

    let listViewShow = listView.filter((view) => view.status === Constant.STATUS_VIEW.SHOW);
    return listViewShow ? listViewShow : [];
}

export const createNewView = async (argsCommon, currentVisibility = '') => {
    let listView = argsCommon.listView;
    // let visibleType = argsCommon.visibilitySetting;
    let visibleType = currentVisibility;

    //check user role: user is member of projectSelected => create only visibility private
    if (argsCommon.userRoleInProject !== Constant.PRIVILEGE_PROJECT.PRJ_MGR) {
        visibleType = Constant.VISIBILITY_SETTING_TYPE.PRIVATE;
    }

    let visibleRange = getVisibleRangeByVisibleType(visibleType, argsCommon);

    let viewStructure = cloneDeep(argsCommon.viewStructure);
    viewStructure.ticketCreatedProjectId = argsCommon.destinationPrjId || '';

    // Remove visibility option;
    delete viewStructure.visibility;

    // validate new viewName
    let newName = generateNameForNewView(listView);
    let listViewLasted = await getListViewByVisibleRange(
        argsCommon.API,
        argsCommon.projectSelectedId,
        visibleRange,
        argsCommon.visibilityKnowledgeAtom ? argsCommon.visibilityKnowledgeAtom : visibleType
    );

    let listCheck = listViewLasted.filter((v) => {
        let viewNameObj = JSON.parse(v.name);
        let viewName = viewNameObj['jp'].text;
        viewName = viewName.trim().toLowerCase();

        return viewName.localeCompare(newName.toLowerCase()) === 0;
    });

    if (listCheck?.length) {
        argsCommon.setIsOpenDialogViewChanged(true);
        return;
    }

    let createViewDto = {
        name: JSON.stringify({
            jp: {
                A: 'F',
                text: newName,
            },
        }),
        affiliationOrganization: argsCommon.organizationSelected.id,
        affiliationProject: argsCommon.projectSelectedId,
        affiliationView: '',
        visibleRange: visibleRange,
        visibleType: visibleType,
        structure: viewStructure ? JSON.stringify(viewStructure) : JSON.stringify({}),
        status: Constant.STATUS_VIEW.SHOW,
        viewType: Constant.VIEW_TYPE.CUSTOM,
        order: generateOrderForNewForm(listView),
        definitionView: Constant.DEFINITION_VIEW.KNOWLEDGE
    };

    let createViewResult = await createViewData(argsCommon.API, createViewDto);

    if (createViewResult) {
        //update list view
        let listViewClone = cloneDeep(argsCommon.listView);
        listViewClone.push(createViewResult);
        argsCommon.setListView(listViewClone);

        //update view selected is new view
        argsCommon.setViewSelected(createViewResult);
    }
};

export const generateNameForNewView = (listView) => {
    let newViewName = '';
    let viewNameDefault = Constant.VIEW_NAME_DEFAULT;

    if (Utils.isEmptyArray(listView)) {
        newViewName = `${viewNameDefault} 1`;
        return newViewName;
    }

    let maxIndex = BigInt(0);
    let regex = new RegExp(`^${viewNameDefault} (\\d*)+$`, 'g');

    for (let i = 0; i < listView.length; i++) {
        let view = listView[i];
        let viewNameObj = JSON.parse(view?.name);
        if (!viewNameObj || typeof viewNameObj !== 'object') continue;
        let viewName = viewNameObj['jp'].text;
        if (Utils.isEmptyString(viewName)) continue;

        let nameMatch = viewName.match(regex);
        if (Utils.isEmptyArray(nameMatch)) continue;

        let indexName = nameMatch[0].replace(`${Constant.VIEW_NAME_DEFAULT} `, '');
        if (Utils.isEmptyString(indexName)) continue;

        let firstChar = indexName.charAt(0);
        if (firstChar === '0') continue;

        indexName = BigInt(indexName);
        if (indexName && indexName > maxIndex) {
            maxIndex = indexName;
        }
    }

    newViewName = `${Constant.VIEW_NAME_DEFAULT} ${maxIndex + 1n}`;

    return newViewName;
};

export const generateOrderForNewForm = (listView) => {
    if (Utils.isEmptyArray(listView)) {
        return 1;
    }
    let maxOrder = Math.max.apply(
        Math,
        listView.map((view) => {
            let order = view.order;
            return order ? order : 0;
        })
    );

    return maxOrder + 1;
};

export const onHandlerDeleteView = async (viewDelete, argsCommon) => {
    argsCommon.setIsConfirmDeleteView(false);
    argsCommon.setIsLoadingView(true);
    // deleteViewData
    let listViewClone = cloneDeep(argsCommon.listView);
    let listViewShow = listViewClone.filter((view) => view.status === Constant.STATUS_VIEW.SHOW);

    // delete view in listView
    let indexView = listViewClone.findIndex((view) => view.id === viewDelete.id);
    if (indexView !== -1) {
        listViewClone.splice(indexView, 1);
    }
    argsCommon.setListView(listViewClone);

    // delete view in DB
    await deleteViewData(argsCommon.API, viewDelete.id);
    argsCommon.setIsLoadingView(false);

    let indexViewShow = listViewShow.findIndex((view) => view.id === viewDelete.id);
    // check case delete current view
    if (argsCommon.viewSelected.id === viewDelete.id && listViewShow.length > 1) {
        if (indexViewShow === 0) {
            let newViewSelected = listViewShow[1];
            if (!Utils.isEmptyObject(newViewSelected)) {
                let currentVisibility = argsCommon.viewStructure.visibility;
                let newView = {
                    ...JSON.parse(newViewSelected.structure),
                    visibility: currentVisibility,
                };
                argsCommon.setViewStructure(newView);
                argsCommon.setViewSelected(newViewSelected);
            }
        } else {
            let newViewSelected = listViewShow[indexViewShow - 1];
            if (!Utils.isEmptyObject(newViewSelected)) {

                let currentVisibility = argsCommon.viewStructure.visibility;
                let newView = {
                    ...JSON.parse(newViewSelected.structure),
                    visibility: currentVisibility,
                };
                argsCommon.setViewStructure(newView);
                argsCommon.setViewSelected(newViewSelected);
            }
        }
    }
};

export const onHandlerHideView = async (viewHide, argsCommon) => {
    argsCommon.setIsConfirmHideView(false);
    argsCommon.setIsLoadingView(true);

    let listViewClone = cloneDeep(argsCommon.listView);
    let listViewShow = listViewClone.filter((view) => view.status === Constant.STATUS_VIEW.SHOW);

    //update view in DB
    await updateViewData(argsCommon.API, viewHide.id, { status: Constant.STATUS_VIEW.HIDDEN, updator: argsCommon.userDetail?.id });

    let indexView = listViewClone.findIndex((view) => view.id === viewHide.id);
    if (indexView !== -1) {
        listViewClone[indexView].status = Constant.STATUS_VIEW.HIDDEN;
    }

    if (!Utils.isEmptyObject(argsCommon?.projectInuseDetail)) {
        const projectSetting = Utils.convertJSONDataToObject(argsCommon?.projectInuseDetail?.projectSetting);
        let usingSynonym = projectSetting?.usingSynonym;
        if (!usingSynonym) {
            listViewShow = listViewShow.filter(view => {
                let structure = Utils.convertJSONDataToObject(view.structure);
                return structure.ticketProperty !== Constant.TICKET_PROPERTY.SYNONYM
            });
        }
    }

    argsCommon.setListView(listViewClone);
    argsCommon.setIsLoadingView(false);

    let indexViewShow = listViewShow.findIndex((view) => view.id === viewHide.id);
    //check case hide current view
    if (argsCommon.viewSelected.id === viewHide.id) {
        if (indexViewShow === 0 && listViewShow.length === 1) {
            argsCommon.setViewSelected({});
        } else if (indexViewShow === 0 && listViewShow.length > 1) {
            let newViewSelected = listViewShow[1];
            if (!Utils.isEmptyObject(newViewSelected)) {
                let currentVisibility = argsCommon.viewStructure.visibility;
                let newView = {
                    ...JSON.parse(newViewSelected.structure),
                    visibility: currentVisibility,
                };
                argsCommon.setViewStructure(newView);
                argsCommon.setViewSelected(newViewSelected);
            }
        } else if (indexViewShow !== 0 && listViewShow.length > 1) {
            let newViewSelected = listViewShow[indexViewShow - 1];
            if (!Utils.isEmptyObject(newViewSelected)) {
                let currentVisibility = argsCommon.viewStructure.visibility;
                let newView = {
                    ...JSON.parse(newViewSelected.structure),
                    visibility: currentVisibility ? currentVisibility : Constant.VISIBILITY_SETTING_TYPE.PRIVATE
                };
                argsCommon.setViewStructure(newView);
                argsCommon.setViewSelected(newViewSelected);
            }
        }
    }
};

export const onHandlerShowView = async (viewShow, argsCommon) => {
    argsCommon.setAddViewPopover(null);
    argsCommon.setIsLoadingView(true);

    //check view was changed
    let isViewChanged = await isViewWasChanged(viewShow, argsCommon);
    if (isViewChanged) {
        argsCommon.setIsOpenDialogViewChanged(true);
        return;
    }

    let listViewClone = cloneDeep(argsCommon.listView);


    let indexView = listViewClone.findIndex((view) => view.id === viewShow.id);
    if (indexView !== -1) {
        listViewClone[indexView].status = Constant.STATUS_VIEW.SHOW;
    }

    let newStructure = Utils.convertJSONDataToObject(listViewClone[indexView].structure);
    let listViewShow = listViewClone.filter((view) => view.status === Constant.STATUS_VIEW.SHOW);
    if (listViewShow.length === 1) {
        let currentVisibility = argsCommon.viewStructure.visibility;
        newStructure.visibility = currentVisibility;
    }
    argsCommon.setViewStructure(newStructure);

    //update view in DB
    await updateViewData(argsCommon.API, viewShow.id, { status: Constant.STATUS_VIEW.SHOW, updator: argsCommon.userDetail?.id });



    let listViewHide = listViewClone.filter((view) => view.status === Constant.STATUS_VIEW.HIDDEN);
    if (listViewHide.length === 0) {
        argsCommon.setOpenListViewHide(false);
    }

    argsCommon.setListView(listViewClone);
    argsCommon.setIsLoadingView(false);
    argsCommon.setViewSelected(listViewClone[indexView]);
    // argsCommon.setTriggerSearch(Date.now().toString());

    // Update ticketCreatedProjectId
    let ticketCreatedProjectId = newStructure.ticketCreatedProjectId || '';

    // check exist project (ticketCreatedProjectId is deleted ??)
    const organizationProject = argsCommon.organizationProject;
    const existPrjListId = [ ...organizationProject.externalProjectList, ...organizationProject.internalProjectList, argsCommon.projectInuseDetail];
    if (!existPrjListId.some(prj => prj.id === ticketCreatedProjectId)) {
        ticketCreatedProjectId = '';
    }

    if (argsCommon.setDestinationPrjId) {
        argsCommon.setDestinationPrjId(ticketCreatedProjectId);
    }
};

export const onDoubleClickView = async (view, argsCommon) => {
    clearTimeout(argsCommon?.clickTimeout);
    argsCommon?.setClickTimeout(null);

    if (argsCommon.isCustomer || view.viewType === Constant.VIEW_TYPE.DEFAULT) return;

    let visibleType = argsCommon.viewStructure.visibility;
    if (
        argsCommon.userRoleInProject === 'MEMBER' &&
        visibleType !== Constant.VISIBILITY_SETTING_TYPE.PRIVATE
    ) {
        return;
    }

    if (
        !isDisplayBtnSettingViewIcon(
            argsCommon.isCustomer,
            argsCommon.userRoleInProject,
            argsCommon.viewStructure,
            argsCommon.isViewFromKnowledgePanel
        )
    ) {
        return;
    }

    let listViewClone = cloneDeep(argsCommon.listView);
    let index = listViewClone.findIndex((v) => v.id === view.id);

    if (index !== -1) {
        listViewClone[index].isEditName = true;
    }

    argsCommon.setListView(listViewClone);
};

export const onEnterViewName = async (e, view, argsCommon) => {
    if (e.key === 'Enter') {
        let newName = e.target.value;

        await onEditViewName(view, newName, argsCommon);
    }
};

export const onBlurViewName = async (e, view, argsCommon) => {
    let newName = e.target.value;
    await onEditViewName(view, newName, argsCommon);
};

export const onEditViewName = async (view, newName, argsCommon) => {
    argsCommon.setIsLoadingView(true);
    //check view was changed
    let viewDetailLatest = await getViewById(argsCommon.API, view.id);
    if (Utils.isEmptyObject(viewDetailLatest)) {
        argsCommon.setIsOpenDialogViewChanged(true);
        argsCommon.setIsLoadingView(false);
    }

    newName = newName.trim();

    let listViewClone = cloneDeep(argsCommon.listView);
    let index = listViewClone.findIndex((v) => v.id === view.id);

    // check view name not change
    let currentNameObj = JSON.parse(view.name);
    let currentName = currentNameObj['jp'].text;
    currentName = currentName.trim().toLowerCase();
    if (currentName.localeCompare(newName.toLowerCase()) === 0) {
        argsCommon.setIsLoadingView(false);
        listViewClone[index].isEditName = false;
        listViewClone[index].isError = false;
        argsCommon.setListView(listViewClone);

        return;
    }

    // check view name blank
    if (Utils.isEmptyString(newName)) {
        argsCommon.setIsLoadingView(false);
        argsCommon.setViewNameErrorType(Constant.EDIT_VIEW_NAME_ERROR_TYPE.BLANK);
        argsCommon.setIsOpenDialogViewNameError(true);

        listViewClone[index].isError = true;
        argsCommon.setListView(listViewClone);

        return;
    }

    let visibleType = argsCommon.viewStructure.visibility;
    let visibleRange = getVisibleRangeByVisibleType(visibleType, argsCommon);

    let listView = await getListViewByVisibleRange(
        argsCommon.API,
        argsCommon.projectSelectedId,
        visibleRange,
        argsCommon.viewStructure.visibility
    );

    let listCheck = listView.filter((v) => {
        let viewNameObj = JSON.parse(v.name);
        let viewName = viewNameObj['jp'].text;
        viewName = viewName.trim().toLowerCase();

        return viewName.localeCompare(newName.toLowerCase()) === 0 && v.id !== view.id;
    });

    if (!Utils.isEmptyArray(listCheck)) {
        argsCommon.setIsLoadingView(false);
        argsCommon.setViewNameErrorType(Constant.EDIT_VIEW_NAME_ERROR_TYPE.DUPLICATE);
        argsCommon.setIsOpenDialogViewNameError(true);

        listViewClone[index].isError = true;
        argsCommon.setListView(listViewClone);
        return;
    }

    // update ticketCreatedProjectId
    const ticketCreatedProjectId = argsCommon.destinationPrjId || '';
    let structure = Utils.convertJSONDataToObject(view.structure);
    structure = {
        ...structure,
        ticketCreatedProjectId: ticketCreatedProjectId
    }

    // update DB
    await updateViewData(argsCommon.API, view.id, {
        name: JSON.stringify({
            jp: {
                A: 'F',
                text: newName,
            },
        }),
        structure: JSON.stringify(structure)
    });

    if (index !== -1) {
        listViewClone[index].name = JSON.stringify({
            jp: {
                A: 'F',
                text: newName,
            },
        });
        listViewClone[index].isEditName = false;
        listViewClone[index].isError = false;
        listViewClone[index].structure = JSON.stringify(structure);

        argsCommon.setListView(listViewClone);
    }

    argsCommon.setIsLoadingView(false);
};

export const saveSearchCondition = async (view, argsCommon) => {
    argsCommon.setIsLoadingView(true);
    let viewStructure = cloneDeep(argsCommon.viewStructure);
    //update view in DB
    await updateViewData(argsCommon.API, view.id, {
        structure: viewStructure ? JSON.stringify(viewStructure) : JSON.stringify({}),
    });

    //update view in listView
    let listViewClone = cloneDeep(argsCommon.listView);
    let index = listViewClone.findIndex((v) => v.id === view.id);
    listViewClone[index].structure = viewStructure
        ? JSON.stringify(viewStructure)
        : JSON.stringify({});
    argsCommon.setListView(listViewClone);

    //update viewSelected
    let viewSelectedClone = cloneDeep(argsCommon.viewSelected);
    viewSelectedClone.structure = viewStructure
        ? JSON.stringify(viewStructure)
        : JSON.stringify({});
    argsCommon.setViewSelected(viewSelectedClone);
    argsCommon?.setViewStructure(viewStructure)

    argsCommon.setIsLoadingView(false);
};

export const isViewWasChanged = async (view, argsCommon) => {
    try {
        argsCommon.setIsLoadingView(true);
        let viewDetailLatest = await getViewById(argsCommon.API, view.id);

        // check change view
        let isChangeView = Utils.isEmptyObject(viewDetailLatest) || (viewDetailLatest.status !== view.status && viewDetailLatest.updator !== argsCommon.userDetail?.id);

        argsCommon.setIsLoadingView(false);
        return isChangeView;
    } catch (error) {
        console.log('isViewWasChanged err >>>', error)
        argsCommon.setIsLoadingView(false);
    }
};

export const onClickOpenMoveView = (view, argsCommon) => {
    let listViewClone = cloneDeep(argsCommon.listView);

    // only one view isMove
    listViewClone.forEach((thisView) => {
        if (thisView.id === view.id) {
            thisView.isMove = true;
        } else {
            thisView.isMove = false;
        }
    });

    argsCommon.setListView(listViewClone);
};

export const onChangeVisibilitySetting = (visibility, argsCommon) => {
    argsCommon.setIsLoadingView(true);
    // let visibilitySettingValue = event.target.value;
    let visibilitySettingValue = visibility;
    // setVisibilitySetting(visibilitySettingValue);

    // Update visibility in recoil state
    let currentViewStructure = cloneDeep(argsCommon.viewStructure);
    currentViewStructure.visibility = visibilitySettingValue;
    argsCommon.setViewStructure(currentViewStructure);

    // await getListViews(argsCommon, argsCommon.projectSelectedId, visibility);
    // let listViewRes = await getListViews(argsCommon, props.projectSelectedId, visibilitySettingValue);
    // let drillDownSearch = buildDrillDownSearchParam(JSON.parse(listViewRes[0].structure));
    // let dataList = await handleSearchTicketKnowledge(argsCommon, props.corporationSelectedId, visibilitySettingValue, drillDownSearch);
    // setTicketKnowledgeList(dataList);

    argsCommon.setIsLoadingView(false);
};

export const onChangeViewSelected = (view, argsCommon, currentCorporationDetail) => {
    if (argsCommon?.clickTimeout) {
        clearTimeout(argsCommon?.clickTimeout);
        argsCommon?.setClickTimeout(null);
        return;
    }

    const loadingChangeViewSelected = () => {
        argsCommon?.setClickTimeout(null);
        argsCommon.setFileNamePdfSelect('');
        argsCommon.setViewSelected(view);
        let limitValue = currentCorporationDetail?.limitValue;
        let usingChatAI = limitValue?.usingChatAI;
        let structureTmp = JSON.parse(view.structure);
        let structure = cloneDeep(structureTmp);
        let isChangeOptionStruct =
            usingChatAI === 0 &&
            structure.options.method === Constant.SETTING_SEARCH_KEYWORD.SIMILAR;
        if (
            [
                Constant.CORPORATION_CONTRACT_TYPE.GUEST,
                Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK
            ].includes(currentCorporationDetail.contractType)
        ) {
            isChangeOptionStruct =
                currentCorporationDetail.inviterUsingChatAI === 0 &&
                structure.options.method === Constant.SETTING_SEARCH_KEYWORD.SIMILAR;
        }
        if (isChangeOptionStruct) {
            structure.options.sort = Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.UPDATED_AT;
            structure.options.method = Constant.SETTING_SEARCH_KEYWORD.AND;
        }
        if (structure?.options?.isIncludePdfFile || structure?.options?.isIncludePdfPage) {
            structure.isIncludePdfFile = 0;
            structure.isIncludePdfPage = 0;
            if (structure?.options?.sort === Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.PAGE_NO) {
                structure.options.sort = Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.UPDATED_AT;
            }
        }
        if (structure?.options?.isIncludeAttachPdf) {
            structure.isIncludeAttachPdf = 0;
        }
        let currentVisibility = argsCommon.viewStructure.visibility;
        let newView = {
            ...structure,
            visibility: currentVisibility
        };
        argsCommon.setViewStructure(newView);
        // argsCommon.setTriggerSearch(Date.now().toString());

        let ticketCreatedProjectId = structure.ticketCreatedProjectId || '';

        // check exist project (ticketCreatedProjectId is deleted ??)
        const organizationProject = argsCommon.organizationProject;
        const existPrjListId = [
            ...organizationProject.externalProjectList,
            ...organizationProject.internalProjectList,
            argsCommon.projectInuseDetail
        ];
        if (!existPrjListId.some(prj => prj.id === ticketCreatedProjectId)) {
            ticketCreatedProjectId = '';
        }

        if (argsCommon.setDestinationPrjId) {
            argsCommon.setDestinationPrjId(ticketCreatedProjectId);
        }

        // if click to current view selected -> trigger reload with default search condition.
        if (view.id === argsCommon.viewSelected.id) {
            argsCommon.setTriggerSearch(Date.now().toString());
        }
        argsCommon?.setClickTimeout(null);
    };

    //handle set timeout to cover for click and double click in same element
    if (view.id === argsCommon.viewSelected.id) {
        const timeout = setTimeout(() => {
            loadingChangeViewSelected();
        }, 300);
        argsCommon?.setClickTimeout(timeout);
    } else {
        loadingChangeViewSelected();
    }
};

export const onBeforeDragStartHandler = (event, argsCommon) => {

    //disable slide before drag start
    let newSetting = { ...argsCommon.settingSlideRecoilState };
    newSetting.disable = true;

    argsCommon.setSettingSlideRecoilState(newSetting);
};

export const onDragViewEnd = async (result, argsCommon) => {
    if (!result.destination) return;
    const element = document.querySelector('#container-knowledge');
    const nodeListView = document.querySelectorAll('.item-knowledge');
    let listViewClone = cloneDeep(argsCommon.listView);
    let listViewShow = listViewClone.filter((v) => v.status === Constant.STATUS_VIEW.SHOW);

    // get index in listViewShow
    let sourceIndex = result.source.index;
    let desIndex = result.destination.index;

    // get item by index in listViewShow
    let itemSource = listViewShow[sourceIndex];
    let itemDes = listViewShow[desIndex];

    // get index in listView
    let sourceIndexListView = listViewClone.findIndex((v) => v.id === itemSource.id);
    let desIndexListView = listViewClone.findIndex((v) => v.id === itemDes.id);

    // move view in listView
    let [viewMove] = listViewClone.splice(sourceIndexListView, 1);
    viewMove.isMove = false;
    listViewClone.splice(desIndexListView, 0, viewMove);

    // update order in listView
    let order = 1;
    listViewClone.forEach((view) => {
        view.order = order;
        order++;
    });
    await argsCommon.setListView(listViewClone);

    // update view in DB
    argsCommon.setIsLoadingView(true);
    Promise.all(
        listViewClone.map((view) => {
            return updateViewData(argsCommon.API, view.id, { order: view.order });
        })
    );

    argsCommon.setIsLoadingView(false);

    let containerRect = element.getBoundingClientRect();
    let posElem = [];

    for (let i = 0; i < nodeListView.length; i++) {
        let id = listViewClone[i]?.id;
        // Gets the amount of pixels currently visible within the container
        let visiblePageWidth = getVisibleWidth(nodeListView[i]);
        posElem.push({ id: id, pos: visiblePageWidth });
    }

    for (let i = 0; i < posElem.length; i++) {
        let item = posElem[i];
        if (item.pos.left + item.pos.width >= containerRect.width - Constant.WIDTH_CHECK_DRAG_END) {
            element.scrollLeft += item.pos.width - (containerRect.width - item.pos.left);
            break;
        }
    }
};

export const createNewViewByDeletedView = async (argsCommon, deletedView, oldViewStructure, listView) => {
    let newName = generateNameForNewView(listView);
    let createViewDto = {
        id: deletedView.id,
        name: JSON.stringify({
            jp: {
                A: 'F',
                text: newName,
            },
        }),
        affiliationOrganization: deletedView.affiliationOrganization,
        affiliationProject: deletedView.affiliationProject,
        affiliationView: '',
        visibleRange: deletedView.visibleRange,
        visibleType: deletedView.visibleType,
        structure: oldViewStructure ? JSON.stringify(oldViewStructure) : JSON.stringify({}),
        status: deletedView.status,
        viewType: Constant.VIEW_TYPE.CUSTOM,
        order: generateOrderForNewForm(listView),
        definitionView: Constant.DEFINITION_VIEW.KNOWLEDGE
    };

    let createViewResult = await createViewData(argsCommon.API, createViewDto);
    return createViewResult;
};

export const isDisplayBtnSettingViewIcon = (isCustomer, userRoleInProject, viewStructure, isViewFromKnowledgePanel) => {
    let visibleType = viewStructure.visibility;

    if (!Utils.isEmptyString(isViewFromKnowledgePanel)) {
        if (isViewFromKnowledgePanel !== Constant.KNOWLEDGE_VIEW_OPTION.PRJ_IN_USE) return false;
        if (
            userRoleInProject === 'MEMBER' &&
            visibleType !== Constant.VISIBILITY_SETTING_TYPE.PRIVATE
        ) {
            return false;
        }

        return true;
    }

    if (isCustomer) return false;
    if (
        userRoleInProject === 'MEMBER' &&
        visibleType !== Constant.VISIBILITY_SETTING_TYPE.PRIVATE
    ) {
        return false;
    }

    return true;
};